module.exports = __webpack_public_path__ + "img/slide5-3.f9af240b.png";